export type VerifiedPurchase = {
  buyerName: string;
  productName: string;
  location: string;
  purchaseTime: string;
};

// Agregá únicamente compras verificadas y reales. Si esta lista está vacía, no se muestra ninguna notificación.
export const verifiedPurchases: VerifiedPurchase[] = [];
